import React, { Component } from 'react';
import Header from '../components/layout/Header';
import Slider from 'react-slick';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PageHeader from "../components/layout/PageHeader";
import { Footer } from '../components/layout/Footer';
import CountUp from 'react-countup';


export class Laundry_services extends Component {

    constructor() {
        super();
        this.state = {
          name: "React"
        };
        this.onChangeValue = this.onChangeValue.bind(this);

    }
    
    onChangeValue(event) {
        console.log(event.target.value);
    }

    render() {
        var slick_slider = {
          dots: false,
          arrow: false,
          autoplay: true,
          infinite: true,
          speed: 1000,
          slidesToShow: 4,
          slidesToScroll: 1,
          rows: 1,
  
          responsive: [{
      
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
        };
        return (

            <div className="site-main">
                <Header/>
            
                <div className="ttm-page-title-row bg-img1 bg-theme-GreyColor" style={{ backgroundImage: 'url("images/bg-image/row-bgimage-1.png")'}}>
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12"> 
                            <div className="title-box text-center">
                                <div className="page-title-heading">
                                <h2 className="title">Laundry services</h2>
                                </div>{/* /.page-title-captions */}
                                <div className="breadcrumb-wrapper">
                                <span>
                                    <a title="Homepage" href={process.env.PUBLIC_URL + '/'} >&nbsp;&nbsp;Home</a>
                                </span>
                                <span>
                                    <a title="Homepage" href={process.env.PUBLIC_URL + '/'} >&nbsp;&nbsp;/ Services</a>
                                </span>
                                <span className="ttm-bread-sep">&nbsp; / &nbsp;</span>
                                <span>Laundry services</span>
                                </div>  
                            </div>
                            </div>{/* /.col-md-12 */}  
                        </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>

                <div className="sidebar clearfix">
                    <div className="container">
                        {/* row */}
                        <div className="row">
                            <div className="col-lg-4 widget-area sidebar-left border-right pr-45 pr-lg-15">
                                <aside className="widget widget-nav-menu">
                                    <h3 className="widget-title">Our services</h3>
                                    <ul>
                                        <li className="d-flex"><a href={process.env.PUBLIC_URL + '/Alterations_repairs'}>Alterations & repairs</a></li>
                                        <li className="d-flex"><a href={process.env.PUBLIC_URL + '/Commercial_laundry'}>Commercial laundry</a></li>
                                        <li className="d-flex"><a href={process.env.PUBLIC_URL + '/Dry_cleaning'}>Dry cleaning</a></li>
                                        <li className="d-flex active"><a href={process.env.PUBLIC_URL + '/Laundry_services'}>Laundry services</a></li>
                                        <li className="d-flex"><a href={process.env.PUBLIC_URL + '/Leather_cleaning'}>Leather cleaning</a></li>
                                        <li className="d-flex"><a href={process.env.PUBLIC_URL + '/Steam_iron'}>Steam iron</a></li>
                                    </ul>
                                </aside>
                                <aside className="widget image-box">
                                    <div className="widget_img">
                                        <img src="./images/single-img-8-369x154.jpg" />
                                    </div>
                                    <div className="featured-imagebox featured-imagebox-service style2">
                                        <div className="featured-image-box-wrapper">
                                            <div className="featured-thumbnail">
                                                <img width="41" height="41" src="./images/whats-up.png" />
                                            </div>
                                            <div className="featured-content">
                                                <div className="featured-title">
                                                    <h3><a href="tel:+123457899">+18 - 2222 - 3555</a></h3>
                                                </div>
                                            </div>
                                        </div>
                                        <h2>Call us for all your laundry needs</h2>
                                    </div>
                                </aside>
                                <aside className="widget widget-download">
                                    <h3 className="widget-title">Download</h3>
                                    <ul className="download">
                                        <li>
                                        <a><h3><a href="/cleano/Laundry_services">Repair</a></h3>
                                            <i className="far fa-file-pdf" /></a>
                                        </li>
                                        <li>
                                            <a><h3><a href="/cleano/Laundry_services">Maintance</a></h3>
                                            <i className="far fa-file-pdf" /></a>
                                        </li>
                                    </ul>
                                    <h3 className="widget-title">Share now</h3>
                                    <div class="ttm-social-links-wrapper mt-20">
                                        <ul className="social-icons">
                                            <li className="social-facebook">
                                                <a target="_blank" href="https://www.facebook.com/preyantechnosys19"><i className="fab fa-facebook-f" aria-hidden="true"></i></a>
                                            </li>
                                            <li className="social-twitter">  
                                                <a target="_blank" href="https://twitter.com/PreyanTechnosys"><i className="fab fa-twitter" aria-hidden="true"></i></a>
                                            </li>
                                            <li className="social-pinterest">
                                                <a target="_blank" href="https://dribbble.com/PreyanTechnosys"><i className="fab fa-dribbble" aria-hidden="true"></i></a>
                                            </li>
                                            <li className="social-instagram">
                                                <a target="_blank" href="https://www.instagram.com/preyan_technosys/"><i className="fab fa-linkedin-in" aria-hidden="true"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                </aside>
                            </div>
                            <div className="col-lg-8 widget-area sidebar-right pl-45 pl-lg-15">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="ttm-service-classic-content">
                                            <h2 className="pt-0">Why choose this service</h2>
                                            <p>We care about your importance to cleanliness. We care about the health you will feel when you return to a
                                            clean home. Because cleanliness is our business. Our expertise is based on experience and we have systems 
                                            suitable for all types of cleaning jobs. Every member of our team is trained and undergoes regular health 
                                            and safety checks to ensure your safety and we are nea certified and we keep up to date with the latest 
                                            guidance</p>
                                        </div>
                                        <div className="bg-theme-SkinColor bg-img1 border-radius-8 mt-40 mb-40" style={{ backgroundImage: 'url("images/bg-image/row-bgimage-1.png")' }}>
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6">
                                                    {/*ttm-fid*/}
                                                    <div className="ttm-fid inside style2 text-theme-WhiteColor">
                                                        <div className="ttm-fid-contents text-left">{/*ttm-fid-contents*/}
                                                        <h3 className="ttm-fid-title">since</h3>{/*ttm-fid-title*/}
                                                            <h4 className="ttm-fid-inner">
                                                                <CountUp start={0} end={1994} duration={500} />
                                                            </h4>
                                                        </div>
                                                    </div>{/* ttm-fid end*/}
                                                </div>
                                                <div className="col-md-6 col-sm-6">
                                                    {/*ttm-fid*/}
                                                    <div className="ttm-fid inside style2 text-theme-WhiteColor">
                                                        <div className="ttm-fid-contents text-left">{/*ttm-fid-contents*/}
                                                        <h3 className="ttm-fid-title">Design</h3>{/*ttm-fid-title*/}
                                                            <h4 className="ttm-fid-inner">
                                                                <CountUp start={0} end={300} duration={100} />
                                                                <span>+</span>
                                                            </h4>
                                                        </div>
                                                    </div>{/* ttm-fid end*/}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <img src="./images/single-img-14-836x399.png" />
                                        </div>
                                        <div className="ttm-service-classic-content">
                                            <h2>Service advantages</h2>
                                            <p>Order for convenient and free shipping on specific days in your area. A minimum order of $100 is 
                                            required to qualify for free shipping, email alert will let you know when free shipping is approaching,
                                            and dont miss it.</p>
                                        </div>
                                        <div className="row mt-20">
                                            <div className="col-md-5">
                                                <div className="featured-icon-box style4">
                                                    <div className="featured-icon">
                                                        <i className="flaticon-steam-iron"></i>
                                                    </div>
                                                    <div className="featured-content">
                                                        <div className="featured-title">
                                                            <h3>24/7 Supports</h3>
                                                        </div>
                                                        <div className="featured-desc">
                                                            <p>Contact us now. Don't miss out on free shipping!</p>
                                                        </div>
                                                        <div className="ttm-iconbox right-140">
                                                            <a href={process.env.PUBLIC_URL + '/Leather_cleaning'} className="ttm-icon ttm-icon_element-border ttm-icon_element-style-round ttm-icon_element-color-grey ttm-icon_element-size-sm" tabindex="0">
                                                                <i className="flaticon-up-right-arrow"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-7">
                                                <img className="border-radius-8 mt-15" src="./images/single-img-15-505x299.png" />
                                            </div>
                                            <p className="mt-20">We believe in vertically integrating as many cleaning processes as possible in order to achieve the high
                                            standards set by ourselves and ultimately by our customer base. We own and operate a state-of-the-art van
                                            that we use to personally collect and deliver your garments in pristine condition, pick up a rag during
                                            business hours.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>{/* row end */}
                    </div>
                </div>
                
            <Footer/>
                        
            </div>
          )
      }
   }

export default Laundry_services;